// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__3Jl07","icon":"styles_icon__3C6zB","icon--black":"styles_icon--black__1vk2C","iconContainer--red":"styles_iconContainer--red__ezsaM"};